import moment from 'moment';
import { PositionEducationRequirementType, UIPositionEducationRequirementOptionsType } from 'types';

export const showRecommendedConnectedUserCount = (recommendedUsersCount: number, connectedUsersCount: number) => {
	return recommendedUsersCount + connectedUsersCount > 2;
};
export function generateDateTimeSlots(skipDays: number = 0) {
	const dates = [];
	const times = [];

	// Generate date slots starting from the specified number of days to skip
	for (let i = skipDays; i < skipDays + 7; i++) {
		const date = moment().clone().add(i, 'days');
		const fullDate: Date = date.toDate();
		dates.push({
			dayText: date.format('ddd'), // Format day as 'Mon', 'Tue', etc.
			dateText: date.format('DD MMM'), // Format date as '28 Mar', '29 Mar', etc.
			fullDate,
		});
	}

	// Generate time slots from 9:00 to 21:00 with a 15-minute interval using moment
	for (let i = 0; i < 48; i++) {
		const time = moment()
			.add(skipDays, 'days') // Add skipDays to the current day
			.hour(9)
			.minute(0)
			.add(i * 15, 'minutes');
		times.push(time.format('hh:mm A'));
	}

	// Add time only if it is greater than current time
	const todaysTimes = times.filter(time => {
		const timeMoment = moment(time, 'hh:mm A');
		const currentTime = moment();
		return timeMoment.isAfter(currentTime);
	});

	return { dates, times, todaysTimes };
}

export const PositionEducationRequirementTypeOptions: UIPositionEducationRequirementOptionsType[] = [
	{ value: PositionEducationRequirementType.AnyDegree, label: 'Any Degree' },
	{ value: PositionEducationRequirementType.AnyGraduates, label: 'Any Graduates' },
	{ value: PositionEducationRequirementType.BCA_MCA, label: 'BCA/MCA' },
	{ value: PositionEducationRequirementType.Btech, label: 'B.Tech' },
	{ value: PositionEducationRequirementType.BtechWithCSE, label: 'B.Tech (CS/IT)' },
];
